import { pdfRegexTest } from './pdfRegexTest';

export const tools = ($http: HttpApi) => ({
  pdfRegexTest: pdfRegexTest($http),
});
